var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_507_1",
    "data-name": "Component 507 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_1387",
    "data-name": "Path 1387",
    fill: "#ff004c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11 15 L 5 15 C 2.794389963150024 15 1 13.20561027526855 1 11 L 1 5 C 1 2.794389963150024 2.794389963150024 1 5 1 L 11 1 C 13.20561027526855 1 15 2.794389963150024 15 5 L 15 11 C 15 13.20561027526855 13.20561027526855 15 11 15 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5 2 C 3.345789909362793 2 2 3.345789909362793 2 5 L 2 11 C 2 12.65421009063721 3.345789909362793 14 5 14 L 11 14 C 12.65421009063721 14 14 12.65421009063721 14 11 L 14 5 C 14 3.345789909362793 12.65421009063721 2 11 2 L 5 2 M 5 0 L 11 0 C 13.76142024993896 0 16 2.238579750061035 16 5 L 16 11 C 16 13.76142024993896 13.76142024993896 16 11 16 L 5 16 C 2.238579750061035 16 0 13.76142024993896 0 11 L 0 5 C 0 2.238579750061035 2.238579750061035 0 5 0 Z",
    stroke: "none",
    fill: "#ff0052"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M1621.752-109.008l1.981,3.044,3.9-7.373",
    transform: "translate(-1616.692 117.65)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFilled);
export default __webpack_public_path__ + "static/media/check_filled.d332d0290d7bf8f9db8ca75abb6dca88.svg";
export { ForwardRef as ReactComponent };